import { render, staticRenderFns } from "./Congregazione.vue?vue&type=template&id=1b63343c&scoped=true&"
import script from "./Congregazione.vue?vue&type=script&lang=js&"
export * from "./Congregazione.vue?vue&type=script&lang=js&"
import style0 from "./Congregazione.vue?vue&type=style&index=0&id=1b63343c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b63343c",
  null
  
)

export default component.exports